module.exports = __webpack_public_path__ + "img/teamBg.d441e2cb.jpg";